import { selectHasSpaces, selectSelectedSpace, selectSpaceInfo, } from 'features/spaces/reducers/selectors';
import React, { memo, useCallback, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import IconCircle from 'design-system/icons/IconCircle';
import IconSpace from 'design-system/icons/IconSpace';
import { rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useColors from 'hooks/useColors';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { selectUserId } from 'reducers/selectors';
const SpaceBanner = () => {
    const navigation = useMainStackNavigation();
    const colors = useColors();
    const spaceInfoRecord = useAppSelector(selectSpaceInfo);
    const selectedSpace = useAppSelector(selectSelectedSpace);
    const hasSpaces = useAppSelector(selectHasSpaces);
    const myId = useAppSelector(selectUserId);
    const { spaceInfo, spaceText } = useMemo(() => {
        const spaceInfo = selectedSpace
            ? spaceInfoRecord[selectedSpace]
            : undefined;
        const currentSpace = spaceInfo?.space;
        if (currentSpace?.isDefault) {
            const spaceText = (<View style={styles.flex}>
          <Text numberOfLines={1} Text-14>
            Private space
          </Text>
        </View>);
            return { spaceInfo, spaceText };
        }
        let memberName = '';
        if (currentSpace) {
            const member = spaceInfo.users?.filter((user) => user.id !== myId);
            if (member && member.length && member[0].firstName)
                memberName = member[0].firstName;
        }
        const spaceText = spaceInfo?.users && (<View style={styles.flex}>
        <Text numberOfLines={1} Text-14>
          <Text Text-14>{`${spaceInfo.space.name} space`}</Text>
          <Spacer w={4}/>
          {spaceInfo.users.length > 1 && (<Text TextThin-14 Secondary>
              with
            </Text>)}
          <Spacer w={4}/>
          {spaceInfo.users.length > 2 ? (<Text TextThin-14 Secondary>
              {`${spaceInfo.users.length} members`}
            </Text>) : (<Text Text-14>{memberName}</Text>)}
        </Text>
      </View>);
        return { spaceInfo, spaceText };
    }, [myId, selectedSpace, spaceInfoRecord]);
    const onPress = useCallback(() => {
        if (spaceInfo?.space?.isDefault) {
            navigation.navigate('PrimarySpaceAccounts', { space: spaceInfo.space });
        }
        else if (spaceInfo?.space) {
            navigation.navigate('EditSpace', { id: spaceInfo.space.id });
        }
    }, [navigation, spaceInfo]);
    return !hasSpaces || !spaceText || !spaceInfo?.space ? null : (<View style={styles.row}>
      <TouchableBounce onPress={onPress} style={styles.container}>
        <IconCircle style={styles.iconCircle} color={colors.background.brandLight}>
          <IconSpace scale={0.6} color={colors.elements.brand} style={styles.iconSpace}/>
        </IconCircle>
        <Spacer w={8}/>
        {spaceText}
      </TouchableBounce>
    </View>);
};
export const SPACE_BANNER_HEIGHT = rem(40);
const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: rem(4),
        paddingBottom: rem(8),
        paddingHorizontal: rem(16),
    },
    iconCircle: { width: rem(24), height: rem(24) },
    iconSpace: {
        borderColor: 'black',
    },
    row: {
        flexDirection: 'row',
        height: SPACE_BANNER_HEIGHT,
    },
    flex: {
        flex: 1,
    },
});
export default memo(SpaceBanner);
